import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedInspectorId: '',
    selectedPropertyUnitId: '',
};

const inspectorSlice = createSlice({
    name: "Inspector",
    initialState,
    reducers: {
        setSelectedInspectorId: (state, action) => {
            state.selectedInspectorId = action.payload;
        },
        resetSelectedInspectorId: (state) => {
            state.selectedInspectorId = '';
        },
    },
});

export const { setSelectedInspectorId, resetSelectedInspectorId } = inspectorSlice.actions;

export default inspectorSlice.reducer;
